import AlimTalkContainer from './AlimTalkContainer';
export default AlimTalkContainer;
